import api from "@/utils/api.js";
import responseHandler from "@/utils/responseHandler.js";

export const requestToken = async ({ dispatch, commit }, payload) => {
	dispatch("setLoading", true, { root: true });

	try {
		const response = await api.requestToken(payload);
		const { data } = response.data;
		commit("SET_TOKEN", data);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};
export const getTokenRequests = async ({ dispatch, commit }) => {
	dispatch("setLoading", true, { root: true });

	try {
		const response = await api.getTokenRequests();
		const { data } = response.data;
		const { requests, page, pages } = data;
		const pageInfo = { page, pages };
		const privateRequests = requests.filter(
			(request) => request.type === "Private"
		);
		commit("SET_TOKEN_REQUESTS", privateRequests);
		commit("SET_TOKEN_REQUESTS_PAGES", pageInfo);
		dispatch("setLoading", false, { root: true });
		return data;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};
export const getTokenRequest = async ({ dispatch, commit }, id) => {
	dispatch("setLoading", true, { root: true });

	try {
		const response = await api.getTokenRequest(id);
		const { data } = response.data;
		commit("SET_TOKEN", data);
		dispatch("setLoading", false, { root: true });
		return data;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getDealMembers = async ({ dispatch, commit }, id) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getDealMembers(id);
		const { data } = response.data;
		commit("SET_DEAL_MEMBERS", data);
		dispatch("setLoading", false, { root: true });
		return data;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};
export const getTokenTransactions = async ({ dispatch, commit }, obj) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getTokenTransactions(obj);
		const { transactions, total, page, pages } = response.data.data;
		commit("SET_TOKEN_TRANSACTIONS", transactions);
		commit("SET_TOTAL_TRANSACTION", total);
		commit("SET_PAGE", page);
		commit("SET_PAGES", pages);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const fetchMemberByName = async ({ commit }, name) => {
	try {
		const response = await api.fetchMemberByName(name);
		const { data } = response.data;
		commit("SET_MEMBER_QUERY", data);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const inviteMember = async ({ }, obj) => {
	try {
		const response = await api.inviteMember(obj);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const deactivateMember = async ({ dispatch }, obj) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.deactivateMember(obj);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};
export const activateMember = async ({ }, obj) => {
	try {
		const response = await api.activateMember(obj);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const removeMember = async ({ }, obj) => {
	try {
		const response = await api.removeMember(obj);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};
export const fetchDealInvestors = async ({ dispatch, commit }, id) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.fetchDealInvestors(id);
		const { data } = response.data;
		commit("SET_DEAL_INVESTORS", data);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return error;
	}
};

export const transferToken = async ({ }, obj) => {
	try {
		const response = await api.transferToken(obj);

		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const updateTokenRequest = ({ dispatch, commit }, payload) => {
	dispatch("setLoading", true, { root: true });
	return new Promise((resolve, reject) => {
		api
			.updateTokenRequest(payload)
			.then((response) => {
				const { data } = response.data;
				commit("SET_TOKEN", data);
				dispatch("setLoading", false, { root: true });
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				dispatch("setLoading", false, { root: true });
				reject(error);
			});
	});
};

export const getDealRoomMembers = async ({ dispatch, commit }, query) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getDealRoomMembers(query);
		const { data } = response.data;
		commit("SET_DEALROOM_MEMBERS", data.members);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};
export const getDealRoomWaitlist = async ({ dispatch, commit }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getDealRoomWaitlist();
		const { data } = response.data;
		commit("SET_DEALROOM_WAITLIST", data.docs);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};
export const getAllDealRoomMembers = async ({ dispatch, commit }, query) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getDealRoomMembers(query);
		const { data } = response.data;
		commit("SET_ALL_DEALROOM_MEMBERS", data.members);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getWaitlistMembers = async ({ dispatch, commit }, query) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getWaitlistMembers(query);
		const { data } = response.data;
		commit("SET_DEALROOM_MEMBERS", data.invites);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getDealByName = async ({ commit }, name) => {
	try {
		const response = await api.getDealByName(name);
		const { data } = response.data;
		const { requests, page, pages } = data;
		const pageInfo = { page, pages };
		commit("SET_TOKEN_REQUESTS", requests);
		commit("SET_TOKEN_REQUESTS_PAGES", pageInfo);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const getCompletedDeals = async ({ commit, dispatch }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getTokens();
		const { data } = response.data;
		const { tokens, page, pages } = data;
		const completedDeals = tokens.filter(
			(token) =>
				token.completed_raise === true &&
				token.type === "Private" &&
				!token.entity
		);
		const pageInfo = { page, pages };
		commit("SET_DEALS", completedDeals);
		commit("SET_DEALS_PAGES", pageInfo);
		dispatch("setLoading", false, { root: true });
		return completedDeals;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getDealByStatus = async ({ commit, dispatch }, status) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getDealByStatus(status);
		const { data } = response.data;
		const { requests, page, pages } = data;
		const pageInfo = { page, pages };
		commit("SET_DEALS", requests);
		commit("SET_DEALS_PAGES", pageInfo);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

// Actions from investor-base
export const getUserTokens = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getInvestorTokens(payload);
		const { tokens, page, pages } = response.data.data;
		commit("SET_INVESTOR_TOKENS", tokens);
		commit("SET_INVESTOR_TOKEN_PAGE", page);
		commit("SET_INVESTOR_TOKEN_PAGES", pages);
		dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getUnlimitedUserTokens = async ({ commit }, payload) => {
	try {
		const response = await api.getInvestorTokens(payload);
		const { tokens } = response.data.data;
		commit("SET_UNLIMITED_INVESTOR_TOKENS", tokens);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getUserDealRooms = async ({ commit, dispatch }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.fetchUserDealRooms();
		const { data } = response.data;
		commit("SET_USER_DEAL_ROOM", data);
		dispatch("setLoading", false, { root: true });
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return error;
	}
};
export const getUserPrivateTokens = async ({ commit }) => {
	try {
		const response = await api.getUserPrivateTokens();
		const { data } = response.data;
		commit("SET_USER_PRIVATE_TOKENS", data);
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const getCompaniesRaising = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getCompaniesRaising(payload);
		const { tokens, page, pages } = response.data.data;
		commit("SET_RAISING_TOKENS", tokens);
		commit("SET_RAISING_PAGES", pages);
		commit("SET_RAISING_PAGE", page);
		dispatch("setLoading", false, { root: true });
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getCompaniesRaised = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getCompaniesRaised(payload);
		const { tokens, page, pages } = response.data.data;
		commit("SET_RAISED_TOKENS", tokens);
		commit("SET_RAISED_PAGES", pages);
		commit("SET_RAISED_PAGE", page);
		dispatch("setLoading", false, { root: true });
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getOrderBooks = async ({ commit, dispatch }, query) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getOrderBooks(query);
		const { orders, page, pages } = response.data.data;
		commit("SET_ORDER_BOOK", orders);
		commit("SET_ORDER_PAGE", page);
		commit("SET_ORDER_PAGES", pages);
		dispatch("setLoading", false, { root: true });
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getPublicTokens = async ({ commit, dispatch }) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getPublicTokens();
		const { data } = response.data;
		commit("SET_PUBLIC_TOKENS", data);
		// dispatch("setLoading", false, { root: true });
	} catch (error) {
		responseHandler.handleError(error);
		// dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getToken = async ({ commit, dispatch }, tokenId) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getToken(tokenId);
		const { data } = response.data;
		commit("SET_TOKEN_INFO", data);
		// dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		// dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return error;
	}
};

export const getAssetInfo = async ({ commit, dispatch }, assetId) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getAssetInfo(assetId);
		const { data } = response.data;
		commit("SET_ASSET_INFO", data);
		// dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		// dispatch("setLoading", false, { root: true });
		return false;
	}
};

export const getTokenBalance = async ({ commit, dispatch }, symbol) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getTokenBalance(symbol);
		const { balance } = response.data.data;
		commit("SET_TOKEN_BALANCE", balance);
		commit("SET_TOKEN_PAYOUT_DETAILS", response.data.data);
		// dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		// dispatch("setLoading", false, { root: true });
		return false;
	}
};

export const getTokenOrders = async ({ commit, dispatch }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.getTokenOrders(payload);
		const { orders } = response.data.data;
		if (payload.data.type === "Buy") commit("SET_BUY_ORDER_BOOK", orders);
		if (payload.data.type === "Sell") commit("SET_SELL_ORDER_BOOK", orders);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const tradeToken = async ({ }, payload) => {
	try {
		const response = await api.tradeToken(payload);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getDealRoomInfo = ({ commit, dispatch }, id) => {
	dispatch("setLoading", true, { root: true });
	return new Promise((resolve, reject) => {
		api
			.getDealRoomInfo(id)
			.then((response) => {
				const { data } = response.data;
				commit("SET_DEAL_ROOM_INFO", data);
				resolve(response);
				// dispatch("setLoading", false, { root: true });
			})
			.catch((error) => {
				// dispatch("setLoading", false, { root: true });
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const getCompanyUpdate = async ({ commit, dispatch }, payload) => {
	try {
		const response = await api.getCompanyUpdate(payload);
		const { tokenUpdates, updates, page, pages } = response.data.data;
		const flatTokenUpdate = tokenUpdates.flat();
		const totalUpdates = updates.concat(flatTokenUpdate.reverse());
		commit("SET_TOKEN_UPDATE", totalUpdates);
		// commit("SET_TOKEN_UPDATE_PAGE", page);
		// commit("SET_TOKEN_UPDATE_PAGES", pages);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

// One deal's updates for its trade page. getCompanyUpdate above is the whole organisation's,
// which the account page lists.
export const getTokenUpdates = async ({ commit }, payload) => {
	if (!payload?.id) return false;
	try {
		const response = await api.getTokenUpdates(payload);
		const data = response.data.data;
		// Either a bare array or { updates, tokenUpdates }, as investor-app allows.
		const updates = Array.isArray(data) ? data : Array.isArray(data?.updates) ? data.updates : [];
		const tokenUpdates = Array.isArray(data?.tokenUpdates) ? data.tokenUpdates.flat().reverse() : [];
		commit("SET_TOKEN_UPDATE", updates.concat(tokenUpdates));
		return true;
	} catch (error) {
		// Never leave another deal's updates showing.
		commit("SET_TOKEN_UPDATE", []);
		responseHandler.handleError(error);
		return false;
	}
};

export const getDealRoomSubscriptionStatus = async (
	{ commit, dispatch },
	id
) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getDealRoomSubscriptionStatus(id);
		const { data } = response.data;
		commit("SET_DEAL_SUBSCRIPTION_STATUS", data);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		// dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getSubscriptionPlans = async ({ commit, dispatch }, id) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getSubscriptionPlans(id);
		const { data } = response.data;
		commit("SET_SUBSCRIPTION_PLANS", data);
		dispatch("setLoading", false, { root: true });
		return data;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		// dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const cancelOrder = async ({ dispatch }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		await api.cancelOrder(payload);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getOrganizationDetails = ({ dispatch, commit }, id) => {
	return new Promise((resolve, reject) => {
		api
			.getOrganizationDetails(id)
			.then((response) => {
				const { data } = response.data;
				dispatch("setLoading", false, { root: true });
				commit("SET_DEAL_ROOM_INFO", data);
				resolve(response);
			})
			.catch((error) => {
				dispatch("setLoading", false, { root: true });
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const searchToken = ({ dispatch, commit }, params) => {
	return new Promise((resolve, reject) => {
		api
			.getTokenByName(params)
			.then((response) => {
				const { tokens, page, pages } = response.data.data;
				if (params.completed_raise) {
					commit("SET_RAISED_TOKENS", tokens);
					commit("SET_RAISED_PAGES", pages);
					commit("SET_RAISED_PAGE", page);
				} else {
					commit("SET_RAISING_TOKENS", tokens);
					commit("SET_RAISING_PAGES", pages);
					commit("SET_RAISING_PAGE", page);
				}
				resolve(response);
			})
			.catch((error) => {
				dispatch("setLoading", false, { root: true });
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const getWhyWeListed = ({ dispatch, commit }, tokenId) => {
	return new Promise((resolve, reject) => {
		api
			.getWhyWeListed(tokenId)
			.then((response) => {
				const { data } = response.data;
				commit("SET_WHY_WE_LISTED", data[0]);
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const getCertificateInfo = ({ dispatch, commit }, tokenId) => {
	return new Promise((resolve, reject) => {
		api
			.getCertificateInfo(tokenId)
			.then((response) => {
				const { data } = response.data;
				commit("SET_CERTIFICATE_INFO", data);
				resolve(response);
			})
			.catch((error) => {
				console.log({ error });
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const getBadgeInfo = ({ dispatch, commit }, badgeId) => {
	return new Promise((resolve, reject) => {
		api
			.getBadgeInfo(badgeId)
			.then((response) => {
				const { data } = response.data;
				commit("SET_BADGE_INFO", data);
				resolve(response);
			})
			.catch((error) => {
				console.log({ error });
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

// No getUserSubscription here. GET /user/organisation/:id/subscription is a user route
// (middleware isUser): an organisation token is refused with a 401, and this app's error handler
// logs out on a 401. A company holds no deal-room subscription; the backend decides at purchase.

export const resetSubScription = ({ commit }) => {
	commit("SET_MEMBERSHIP_STATUS", null);
	commit("TokenModule/SET_DEAL_SUBSCRIPTION_STATUS", null, { root: true });
};

export const submitCommitment = async (_, payload) => {
	try {
		return await api.submitCommitment(payload);
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const amendCommitment = async (_, payload) => {
	try {
		return await api.amendCommitment(payload);
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const withdrawCommitment = async (_, commitmentId) => {
	try {
		return await api.withdrawCommitment(commitmentId);
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getCommitments = async ({ commit }, params) => {
	try {
		const response = await api.getCommitments(params);
		commit("SET_COMMITMENTS", response.data.data);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getOfferingBook = async ({ commit }, { id, tranche } = {}) => {
	try {
		const response = await api.getOfferingBook(id, tranche ? { tranche } : undefined);
		commit("SET_OFFERING_BOOK", response.data.data);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

// Walks every page. /tokens/raised sorts newest first, so stopping at page 1 silently
// dropped the oldest listings once there were more than `limit` of them.
export const getExchangeListings = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const first = await api.getExchangeListings({ ...payload, page: 1 });
		const { tokens: firstTokens, pages } = first.data.data;
		const rest = await Promise.all(
			Array.from({ length: Math.max((Number(pages) || 1) - 1, 0) }, (_, i) =>
				api.getExchangeListings({ ...payload, page: i + 2 })
			)
		);
		// Keyed by id: a listing created between two page requests shifts the pages by one
		// and would otherwise appear twice.
		const byId = new Map();
		[firstTokens || [], ...rest.map((r) => r.data.data.tokens || [])]
			.flat()
			.forEach((t) => byId.set(t._id || t.id, t));
		commit("SET_EXCHANGE_LISTINGS", [...byId.values()]);
		dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		commit("SET_EXCHANGE_LISTINGS", []);
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return false;
	}
};

// Fetch "now raising" companies for the Exchange's Recently Listed section.
// Uses the raising feed (/tokens/raising), not the raised/secondary feed.
export const getExchangeRaising = async ({ commit }, payload) => {
	try {
		const response = await api.getCompaniesRaising(payload);
		const { tokens } = response.data.data;
		commit("SET_EXCHANGE_RAISING", tokens || []);
		return true;
	} catch (error) {
		commit("SET_EXCHANGE_RAISING", []);
		return false;
	}
};

// Deep-search a response payload for the transaction/activity array, whatever
// key the backend wraps it under (transactions, activities, docs, results, …).
// Prefers arrays whose items look like activity records (have type/createdAt).
const findActivityArray = (root) => {
	const queue = [root];
	let fallback = null;
	while (queue.length) {
		const node = queue.shift();
		if (Array.isArray(node)) {
			const looksLikeActivity = node.some(
				(i) => i && typeof i === "object" && ("createdAt" in i || "type" in i)
			);
			if (looksLikeActivity) return node;
			if (!fallback && node.length && typeof node[0] === "object") fallback = node;
			continue;
		}
		if (node && typeof node === "object") {
			Object.values(node).forEach((v) => {
				if (v && typeof v === "object") queue.push(v);
			});
		}
	}
	return fallback || [];
};

// Recent market-wide trades for the active currency. Fails silently (no toast)
// so a transient error just yields an empty feed rather than blocking the page.
export const getMarketActivity = async ({ commit }, query) => {
	commit("SET_MARKET_ACTIVITY_LOADING", true);
	try {
		const response = await api.getMarketActivity(query);
		const activity = findActivityArray(response && response.data);
		commit("SET_MARKET_ACTIVITY", activity);
	} catch (error) {
		commit("SET_MARKET_ACTIVITY", []);
	} finally {
		commit("SET_MARKET_ACTIVITY_LOADING", false);
	}
	return true;
};

// Portfolio value time-series for the Invest growth chart. Fails silently (no
// toast) so a missing/erroring endpoint just yields an empty series and the
// chart falls back to its ghost state rather than blocking the page.
export const getPortfolioPerformance = async ({ commit }, query) => {
	commit("SET_PORTFOLIO_PERFORMANCE_LOADING", true);
	try {
		const response = await api.getPortfolioPerformance(query);
		const data = response.data && response.data.data;
		const series = Array.isArray(data)
			? data
			: (data && (data.series || data.points || data.performance)) || [];
		commit("SET_PORTFOLIO_PERFORMANCE", series);
	} catch (error) {
		commit("SET_PORTFOLIO_PERFORMANCE", []);
	} finally {
		commit("SET_PORTFOLIO_PERFORMANCE_LOADING", false);
	}
	return true;
};

// Count of a user's orders for a given filter. Reuses getOrderBooks rather than adding an
// endpoint; swallows failures because it only feeds a badge count.
export const getOrderBookCount = async (_, query) => {
	try {
		const response = await api.getOrderBooks(query);
		const { orders } = response.data.data;
		return { count: orders.length };
	} catch (error) {
		return { count: 0 };
	}
};

// Same payload as getOfferingBook, but returns it instead of committing.
// The listing fetches one book per card; committing each would thrash the single
// offeringBook slot the deal page reads.
export const fetchOfferingBook = async (_, { id, tranche } = {}) => {
	try {
		const response = await api.getOfferingBook(id, tranche ? { tranche } : undefined);
		return response.data.data;
	} catch (error) {
		return null;
	}
};

// The exchange page's headline figures, counted on the server (/transaction/market-stats).
// Cleared on failure, so the page shows a dash rather than another currency's numbers.
export const getExchangeStats = async ({ commit }, query) => {
	try {
		const response = await api.getExchangeStats(query);
		const body = response && response.data;
		commit("SET_EXCHANGE_STATS", (body && body.data && body.data.stats) || null);
	} catch (error) {
		commit("SET_EXCHANGE_STATS", null);
	}
	return true;
};
